import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.374 13.034c.8.156 2.1.216 5.91.283 3.176.048 5.975-.003 9.27-.238a2.7 2.7 0 0 0 1.396-.677c.243-.231.384-.44.55-.834.265-.625.36-1.227.477-2.93.03-.514.03-3.43 0-3.944l-.02-.325c-.065-1.02-.14-2.239-.81-3.238-.346-.432-.934-.766-1.56-.878C16.801.112 13.456 0 10.006 0 6.551 0 3.212.112 2.43.253a2.7 2.7 0 0 0-1.333.64C.36 1.541.241 2.608.136 3.571L.1 3.868c-.149 1.872-.12 3.547 0 5.595.078.908.133 1.28.274 1.726.164.536.376.922.643 1.176.344.334.815.565 1.356.669m10.95-6.355.002.002.007-.007zm0 0a444 444 0 0 0-3.626-1.828l-1.365-.684v5c.867-.452 1.757-.884 2.605-1.297q1.203-.575 2.385-1.19z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }